<template>
  <div>
    <div class="mine-box-title">修改支付密码</div>
    <div class="mini-form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="支付密码" prop="password"
                          :rules="[
      { required: true, message: '请输入支付密码', trigger: 'blur' },
    ]"
            >
              <el-input
                  type="password"
                  placeholder="请输入支付密码"
                  v-model="formData.password"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="确认支付密码" prop="password2"
                          :rules="[
      { required: true, message: '请再次输入支付密码', trigger: 'blur'},
    ]"
            >
              <el-input
                  type="password"
                  placeholder="请再次输入支付密码"
                  v-model="formData.password2"

              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="短信验证码" prop="code"
                          :rules="[
      { required: true, message: '请输入短信验证码', trigger: 'blur'},
    ]"
            >
              <el-input
                  type="text"
                  placeholder="请输入短信验证码"
                  v-model="formData.code"
              ></el-input>
              <el-button type="primary" @click.prevent="getCode">{{ clockSecond > 0 ? clockSecond + 's获取验证码' : '获取验证码' }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">确定
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>

      <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
    </div>
  </div>

</template>
<style scoped>
.btn {
  padding: 0 0.3rem;
  margin-top: 0.3rem;
}

.mine-box-title {
  height: 33px;
  font-size: 24px;
  font-weight: 500;
  color: #333333;
  line-height: 33px;
  margin-bottom: 13px;
}

</style>

<script>
import {Dialog, Toast} from 'vant';
import LoginDialog from '@/components/LoginDialog.vue';

export default {
  name: 'PayPassword',
  components: {
    Toast, LoginDialog
  },
  data: function () {
    return {
      saveLoading: false,
      loginShow: false,
      formData: {
        password: '',
        password2: '',
        code: '',
      },
      clockSecond: 0,
      formValidate: false,
      loading: false
    }
  },
  filter: {},
  mounted() {
    document.title = '修改支付密码'
  },
  destroyed() {
  },
  methods: {
    getCode() {
      let that = this;
      if (that.clockSecond > 0) {
        return;
      }
      this.$api.get('/api/user/phonecode', {}, (res) => {
        Toast(res.msg)
        that.clockSecond = 60;
        var t = setInterval(function () {
          if (that.clockSecond > 0) {
            that.clockSecond = that.clockSecond - 1
          } else {
            clearInterval(t);
          }
        }, 1000)
      }, (res) => {
        console.log(res);
        if (res.code == 401 || res.code == 402) {
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
        that.loading = false;
      })
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      // console.log(that.formData, that.$refs[formName])
      that.$refs[formName].validate((valid) => {
        if (valid) {
          // if (that.formData.heying.length == 0) {
          //   this.$message.warning('请上传队伍照片');
          //   return
          // }
          that.saveLoading = true;
          that.$api.get('/api/user/resetPayPassword', that.formData, (res) => {
            that.$message.success("修改成功")
            that.$router.go(-1)
            that.saveLoading = false;
          }, (res) => {
            if (res.code == 401 || res.code == 402) {
              that.loginShow = true
            } else {
              Toast(res.msg)
            }
            that.saveLoading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  }
}
</script>



// WEBPACK FOOTER //
// PayPassword.vue?4a341058